import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import LaunchIcon from '@material-ui/icons/Launch'
import moment from 'moment'

export default class FinishDayForm extends Component {
  static propTypes = {
    hiboutikAccount: PropTypes.string.isRequired,
    dateSynth: PropTypes.string,
    onClick: PropTypes.func
  }
  handleSubmitClick = e => {
    this.refs.form.submit()
    if (this.props.onClick) {
      this.props.onClick()
    }
  }
  render() {
    const { hiboutikAccount, dateSynth } = this.props
    return (
      <div>
        <Button
          variant="raised"
          color="primary"
          onClick={this.handleSubmitClick}>
          Clôturer la journée
          <LaunchIcon style={{ marginLeft: 10 }} color="inherit" />
        </Button>
        <form
          ref="form"
          method="post"
          action={`https://${hiboutikAccount}.hiboutik.com/#synt_imp`}
          target="_blank">
          <input type="hidden" name="show_tab" value="synthese" />
          {dateSynth && (
            <input
              type="hidden"
              name="ma_boutique_synthese_affiche"
              value="1"
            />
          )}
          {dateSynth && (
            <input
              type="hidden"
              name="ma_date_affiche_stats"
              value={moment(dateSynth).format('YYYY-MM-DD')}
            />
          )}
          {dateSynth && (
            <input type="hidden" name="mon_user_affiche_stats" value="" />
          )}
          <input type="hidden" name="nom_button_form" value="Synthèses" />
          <input
            type="hidden"
            name="affiche_ma_section_accordion"
            value="synt_imp"
          />
        </form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/hiboutikForms/FinishDayForm.js